/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Modal styled component for wrapping and centralizing content
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.12.0
 */

import styled from 'styled-components';

export const ModalCenterStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .modal-popup-title:not(:first-child) {
        margin-top: 32px;
    }

    .success-modal-extraText {
        margin-top: 16px;
    }
`;
